import { Model } from './model';
import { Expose } from 'class-transformer';

export class ExportedFile extends Model {
  @Expose() fileUri: string;
  @Expose() message: string;
  @Expose() lastRefreshTime:Date;
}
